import { requestGet, requestPost, requestPatch, baseURL } from "./ajax"

export const updateParticipantByUUID = (participantUUID, participantNewDetail) => {
    return requestPatch(`participants/${participantUUID}`, participantNewDetail)
}

export const getParticipantProductRolesByParticipantUUID = (participantUUID) => {
    return requestGet(`participants/${participantUUID}/product-roles`)
}

export const getParticipantByParticipantUUID = (participantUUID) => {
    return requestGet(`participants/${participantUUID}`)
}

export const resendInvitationLink = (participantUUID) => {
    return requestPost(`participants-public/participants/${participantUUID}/resendInvitationLink`)
}

export const resendAssessmentLink = (participantUUID) => {
    return requestPost(`participants-public/participants/${participantUUID}/resendAssessmentLink`)
}

export const getDesignations = (companyId) => {
    return requestGet(`designations`, { companyId })
}

export const getDepartments = (companyId) => {
    return requestGet(`departments`, { companyId })
}

export const getQuestionsByParticipantUUID = (participantUUID) => {
    return requestGet(`participants/${participantUUID}/questions`)
}

export const getResponsesByParticipantUUID = (participantUUID) => {
    return requestGet(`participants/${participantUUID}/responses`)
}

export const getChoicesByQuestionId = (questionId) => {
    return requestGet(`questions/${questionId}/choices`)
}

export const createNewResponse = (newResponseDetail) => {
    return requestPost(`responses`, newResponseDetail)
}

export const updateResponseByResponseId = (responseId, newResponseDetail) => {
    return requestPatch(`responses/${responseId}`, newResponseDetail)
}

export const bulkCreateResponse = ({ participantId, projectId, companyId, newResponseList, updateList }) => {
    return requestPost("responses/responses-bulk-action", { participantId, projectId, companyId, newResponseList, updateList })
}

export const beforeunloadResponse = (createList, updateList, participantDetail) => {
    const blobDetailList = new Blob(
        [
            JSON.stringify({
                newResponseList: createList,
                updateList,
                participantDetail,
            }),
        ],
        { type: "application/json; charset=UTF-8" }
    ) // the blob
    navigator.sendBeacon(`${baseURL}/participants-public/responses/responses-bulk`, blobDetailList)
}
